// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kNfTsgGaiQGfIIL5CmaD {
  height: auto;
  display: flex;
  background-color: var(--md-grey-color);
  flex-direction: column;
  overflow: hidden;
  color: var(--white-color);
}

.P3vlA4v0lUxFtS7zrRVf {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-color);
  background-color: var(--keyword-color);

  flex-direction: column;
}

.ezD8i7xta8bouvR7ERqI {
  display: flex;
  flex-direction: row;

  align-items: center;
}

.P3vlA4v0lUxFtS7zrRVf h1 {
  font-size: var(--step-3);
}

.xkrodzCalQN2HVTEr7Qh {
  width: 80%;
}

.xkrodzCalQN2HVTEr7Qh p {
  font-size: var(--step-1);
  line-height: var(--base-line-height);
}

.IKsHf4BEN8IaEuJ1ApW6 p {
  font-size: var(--step-1);
  line-height: var(--base-line-height);
}

.IKsHf4BEN8IaEuJ1ApW6 {
  margin-top: 2rem;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 5rem;
}

.GS9coyoQn9LtWvpp96X5 {
  padding-top: 5px;
}

.VSAMOUDTxXXAY9i0hE5d {
  background-color: transparent;
  padding: 0.5rem;
  width: 95%;
}

.QCDCk3_zlCEPK0JTalwE {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.UDJsnVHGvOgk4kSTPkjs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: var(--space-4xs);
}

.cG5NA25qgKt0vRiQAVKg {
  padding-bottom: 3rem;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media screen and (min-width: 1024px) {
  .P3vlA4v0lUxFtS7zrRVf {
    flex-direction: row;
    padding-bottom: 5rem;
  }

  .IKsHf4BEN8IaEuJ1ApW6 {
    width: 50%;
    padding-right: 3rem;
  }

  .xkrodzCalQN2HVTEr7Qh {
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: center;
    padding-left: 5rem;
  }

  .xkrodzCalQN2HVTEr7Qh p {
    max-width: 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AllKeywordsPage/AllKeywordsPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,sCAAsC;;EAEtC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".keywordsPage {\n  height: auto;\n  display: flex;\n  background-color: var(--md-grey-color);\n  flex-direction: column;\n  overflow: hidden;\n  color: var(--white-color);\n}\n\n.aboutSection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-color);\n  background-color: var(--keyword-color);\n\n  flex-direction: column;\n}\n\n.aboutSectionTitle {\n  display: flex;\n  flex-direction: row;\n\n  align-items: center;\n}\n\n.aboutSection h1 {\n  font-size: var(--step-3);\n}\n\n.topAbout {\n  width: 80%;\n}\n\n.topAbout p {\n  font-size: var(--step-1);\n  line-height: var(--base-line-height);\n}\n\n.bottomAbout p {\n  font-size: var(--step-1);\n  line-height: var(--base-line-height);\n}\n\n.bottomAbout {\n  margin-top: 2rem;\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 5rem;\n}\n\n.iconWrapper {\n  padding-top: 5px;\n}\n\n.customAccordion {\n  background-color: transparent;\n  padding: 0.5rem;\n  width: 95%;\n}\n\n.pillLinkSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.relatedInfoBox {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: var(--space-4xs);\n}\n\n.monthGroup {\n  padding-bottom: 3rem;\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n@media screen and (min-width: 1024px) {\n  .aboutSection {\n    flex-direction: row;\n    padding-bottom: 5rem;\n  }\n\n  .bottomAbout {\n    width: 50%;\n    padding-right: 3rem;\n  }\n\n  .topAbout {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    justify-content: center;\n    padding-left: 5rem;\n  }\n\n  .topAbout p {\n    max-width: 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keywordsPage": `kNfTsgGaiQGfIIL5CmaD`,
	"aboutSection": `P3vlA4v0lUxFtS7zrRVf`,
	"aboutSectionTitle": `ezD8i7xta8bouvR7ERqI`,
	"topAbout": `xkrodzCalQN2HVTEr7Qh`,
	"bottomAbout": `IKsHf4BEN8IaEuJ1ApW6`,
	"iconWrapper": `GS9coyoQn9LtWvpp96X5`,
	"customAccordion": `VSAMOUDTxXXAY9i0hE5d`,
	"pillLinkSection": `QCDCk3_zlCEPK0JTalwE`,
	"relatedInfoBox": `UDJsnVHGvOgk4kSTPkjs`,
	"monthGroup": `cG5NA25qgKt0vRiQAVKg`
};
export default ___CSS_LOADER_EXPORT___;
